module.exports = __webpack_public_path__ + "img/dialog_bg_1.f1f903a1.png";